<template>
  <div
    class="t-flex"
    :style="`
      ${justify_content?`justify-content: ${justify_content};`:''}
      ${align_items?`align-items: ${align_items};`:''}
      ${width?`width: ${width}`:''}
      ${height?`height: ${height}`:''}
      ${gap?`gap: ${gap}`:''}
      ${wrap?`flex-wrap: ${wrap}`:''}
      ${direction?`flex-direction: ${direction};`:''} 
    `"
    >
    <slot/>
  </div>
</template>
<script>
  export default {
    props: ['justify_content', 'height', 'width', 'align_items', 'gap', 'wrap', 'direction'],
    data: () => ({
    }),
  }
</script>
<style>
  .t-flex {
    display: flex;
  }
</style>
